<template>
	<v-card class="pa-4">
		<v-text-field v-model="post.title" label="Post Title" class="mb-4"></v-text-field>
		<TextEditor :elements="elements"></TextEditor>   
		<h4 class="mw-h3 mt-8">Post Settings</h4>
		<v-checkbox hide-details v-model="post.displayTitle" label="Display Title"></v-checkbox>
		<v-checkbox hide-details v-model="post.showLogInForm" label="Show Login Form"></v-checkbox>
		<v-checkbox hide-details v-model="post.loggedInOnly" label="Logged in users only?"></v-checkbox>
		<v-select multiple v-if="post.loggedInOnly" v-model="post.access" label="Who can see this post?" :items="roles" class="mb-4" :value="true"></v-select>
		<NamedUrlField type="post" :id="post.id" label="Custom post URL"></NamedUrlField>
		<p class="text-right mt-5">
			<v-btn color="green" dark class="mr-4" @click="save" >Save </v-btn>
		</p>
	</v-card>
</template>
<style lang="less" scoped>
	@import "~vue-wysiwyg/dist/vueWysiwyg.css";
</style>
<script>
import NamedUrlField from "../tools/NamedUrlField.vue";
import TextEditor from "../edits/TextEditor.vue"
export default {
	name: 'EditPost',
	props: {
		post: {type: Object},
	},
	data: () => ({
		editorType: "editor",
		styleDialog: false,
		elements: [],
		roles: [
			{text: 'Admin', value: 'admin', }, 
			{text: 'Client', value: 'client'}, 
			{text: 'Panelist', value: 'panelmember'}, 
		], 
	}),
	components: {
		NamedUrlField: NamedUrlField,
		TextEditor: TextEditor
	},
	methods: {
		save() {
			var self = this;
			let update = {};
			for( var key in self.post ){
				if( typeof self.post[key] !== 'undefined'){
					update[key] = self.post[key];	
				} 
			}
			update.elements = self.elements;
			self.$store.dispatch("updateDoc", {
				doc: "posts/" + self.post.id,
				data: update,
				action: "update"
			}).then( function(){
				self.$emit("saved");
				self.editorData = self.post.content
			}) 
		},
	},
	watch: {
		editorData(){
			this.post.content = this.editorData;
		},
		post: {
			immediate: true, 			
			handler(){
				if( this.post.elements ){
					this.elements = this.post.elements;
				}
			}
		}
	}, 
	created(){
	}
}
	</script>